import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

function InfoButtonWithModal({ enableEdit }) {
	const [showModal, setShowModal] = useState(false);

	const handleShow = () => setShowModal(true);
	const handleClose = () => setShowModal(false);

	return (
		<div className="position-relative">
			{!enableEdit && (
				<span
					className="position-absolute my-ice rounded-circle"
					style={{
						top: "-20px",
						left: "-25px",
						width: "30px",
						height: "30px",
						cursor: "pointer",
						transform: "translate(20%, -20%)",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
					onClick={handleShow}
				>
					<i className="bi bi-info" style={{ fontSize: "2rem" }}></i>
				</span>
			)}

			<Modal show={showModal} onHide={handleClose} centered>
				<Modal.Title className="d-flex align-items-center m-2 mb-0">
					<i className="bi bi-chat-quote-fill me-2 my-color"></i>
					Conversation Starters
				</Modal.Title>
				<Modal.Body>
					<p className="mb-2 fst-italic">Here you can write a few ideas to start a conversation...</p>
					<ul>
						<li>What has caught your attention recently?</li>
						<li>What have you found interesting lately?</li>
						<li>If you could travel anywhere, where would you go?</li>
						<li>What's a hobby or activity you love doing?</li>
						<li>Do you prefer the beach or the mountains?</li>
						<li>What’s the best meal you’ve ever had?</li>
					</ul>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default InfoButtonWithModal;
